





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import LendingTermSettingsEdit from '@/components/Products/Forms/Lending/LendingTermSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'LendingTermSettingsEditDialog', components: { LendingTermSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
            await ProductDetailsModule.getRateSources();
        }
    }

    get productType() {
        return ProductDetailsModule.product.generalSettings.subType;
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editLendingTermSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
